import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import "./AssetDetailPopup.css";
import printIcon from "../assets/icons/icon_print1.svg"
import closeIcon from "../assets/icons/icon_close1.svg"
import api from '../services/api';
import getLatestVerification from "../services/verificationRecordsSort";

export default function AssetDetailPopup() {
    const { assetNo } = useParams();
    const [asset, setAsset] = useState(null);
    const [style, setStyle] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        const originalAlert = window.alert;
        window.alert = () => { };

        const fetchAssetData = async () => {
            if (!assetNo) return;

            try {
                setLoading(true);
                // Get current user from session
                const userResponse = await api.get('/auth/me');
                const userId = userResponse.data.user_id;

                // Use the same API call as ResultsPageNew.js (from AssestDraft.js pattern)
                // This API should return complete asset details with all fields
                const { data } = await api.get(`/asset/${userId}/${assetNo}`);

                if (data) {
                    setAsset(data);
                    console.log("Asset Data:", data);
                } else {
                    setError('Asset not found');
                }
            } catch (err) {
                console.error('Error fetching asset data:', err);
                if (err.response?.status === 404) {
                    setError('Asset not found or you do not have access to this asset');
                } else if (err.message === 'Session expired') {
                    setError('Session expired. Please login again.');
                } else {
                    setError('Failed to load asset data');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchAssetData();
        return () => {
            window.alert = originalAlert;
        };
    }, [assetNo]);

    const handleClose = () => {
        window.close();
    };

    const formatDate = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return isoString;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    if (loading) return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading asset details...</div>;
    if (error) return <div style={{ padding: '2rem', textAlign: 'center', color: 'red' }}>Error: {error}</div>;
    if (!asset) return <div style={{ padding: '2rem', textAlign: 'center' }}>Asset not found</div>;

    const verification = getLatestVerification(asset.verification);

    const software = asset.sw_desc ? asset.sw_desc.split('|') : [];

    return (
        <>
            <div className="asset-container" style={{ fontFamily: 'GEG-Light, Arial, sans-serif' }}>
                <div className="header">
                    <div className="header-icons">
                        <img src={closeIcon} alt="Close" className="icon" onClick={handleClose} title="Close" />
                    </div>
                </div>

                <div className="table-container">
                    <section className="form-section">
                        <table className="form-table">
                            <tbody>
                                <tr><td colSpan={4} style={{ textAlign: 'center', fontWeight: 'bold', backgroundColor: '#e9ecef' }}>Details of Asset</td></tr>
                                <tr><td>Asset No</td><td colSpan={3}>{asset.lad_Equip || asset.asset_no}</td></tr>
                                <tr><td>Asset Type</td><td>{asset.asset_type}</td>
                                    <td>Asset Sub Type</td><td>{asset.asset_sub_type}</td></tr>
                                <tr><td>Asset Make</td><td>{asset.asset_make}</td>
                                    <td>Asset Model</td><td>{asset.asset_model}</td></tr>
                                <tr><td>Asset Sr No</td><td colSpan={3}>{asset.asset_srno}</td></tr>
                                <tr><td>Email ID</td><td>{asset.emailId}</td>
                                    <td>Extn</td><td>{asset.extn || ''}</td></tr>
                                <tr><td>BC/RC/CC</td><td colSpan={3}>{asset.bc || ''} / {asset.rc || ''} / {asset.cc || ''}</td></tr>
                                <tr><td>Phone</td><td>{asset.phone || ''}</td>
                                    <td>Mobile</td><td>{asset.mobile || ''}</td></tr>
                                <tr><td>Users</td><td>{asset.users}</td>
                                    <td>Company</td><td>{asset.comp}</td></tr>
                                <tr><td>HO / Branch</td><td>{asset.ho}</td>
                                    <td>Plant / Branch</td><td>{asset.plant_branch}</td></tr>
                                <tr><td>Division</td><td>{asset.div}</td>
                                    <td>Department</td><td>{asset.dept}</td></tr>
                                <tr><td>Date of Purchase</td><td>{formatDate(asset.date_of_purchase) || ''}</td>
                                    <td>AMC</td><td>{asset.amc || ''}</td></tr>
                                <tr><td>AMC Warranty Vendor</td><td>{asset.amc_warranty_vendor || ''}</td>
                                    <td>Date Of AMC Warranty Expiry</td><td>{formatDate(asset.amc_warranty_expiry) || ''}</td></tr>
                                <tr><td>Period of AMC warranty</td><td>{asset.amc_warranty_period || ''}</td>
                                    <td>Fixed/Rental</td><td>{asset.fixed_rental || ''}</td></tr>
                                <tr><td>Schedule No.</td><td colSpan={3}>{asset.schedule_no || ''}</td></tr>
                                <tr><td>VAL No.</td><td>{asset.val_no || ''}</td>
                                    <td>VAL Date</td><td>{formatDate(asset.val_date) || ''}</td></tr>
                                <tr><td>IP Address</td><td>{asset.ip || ''}</td>
                                    <td>MAC Address</td><td>{asset.mac || ''}</td></tr>
                                <tr><td>Date Of Installation</td><td>{formatDate(asset.installation_date) || ''}</td>
                                    <td>PO NO</td><td>{asset.po_no || ''}</td></tr>
                                <tr><td>Item Cost</td><td>{asset.item_cost || ''}</td>
                                    <td>PO Date</td><td>{formatDate(asset.po_date) || ''}</td></tr>
                                <tr><td>Remarks</td><td colSpan={3}>{asset.remarks || ''}</td></tr>
                                <tr><td>Insurance</td><td>{asset.insurance || ''}</td>
                                    <td>Insurance Date</td><td>{formatDate(asset.insurance_date) || ''}</td></tr>
                                <tr><td>First Use Date</td><td>{formatDate(asset.first_use_date) || ''}</td>
                                    <td>Not In Use Date</td><td>{formatDate(asset.not_in_use_date) || ''}</td></tr>
                                <tr><td>In Use Ind</td><td>{asset.in_use_ind || ''}</td>
                                    <td>On Network Ind</td><td>{asset.on_network_ind || ''}</td></tr>
                                <tr><td>Verified By</td><td>{asset.verified_by || verification.verified_by || ''}</td>
                                    <td>Verified On</td><td>{formatDate(asset.verified_on) || ''}</td></tr>
                                <tr><td>NIC Make And Model</td><td colSpan={3}>{asset.nic_make_model || ''}</td></tr>
                                <tr><td>Details</td><td colSpan={3}>{asset.details || ''}</td></tr>
                            </tbody>
                        </table>

                        {(asset.asset_type === 'Computer' || asset.asset_type === 'Servers') && (
                            <>
                                <table className="form-table">
                                    <tbody>
                                        <tr><td>Mouse Type</td><td>{asset.mouse_type || ''}</td>
                                            <td>Monitor Type</td><td>{asset.monitor_type || ''}</td></tr>
                                        <tr><td>Monitor Size</td><td>{asset.monitor_size || ''}</td>
                                            <td>PC Type</td><td>{asset.pc_type || ''}</td></tr>
                                    </tbody>
                                </table>

                                <table className="form-table">
                                    <tbody>
                                        <tr><td>RAM</td><td>{asset.ram || ''}</td>
                                            <td>RAM Type</td><td>{asset.ram_type || ''}</td></tr>
                                        <tr><td>RAM Type Details</td><td colSpan={3}>{asset.ram_type_details || ''}</td></tr>
                                        <tr><td>HDD</td><td>{asset.hdd || ''}</td>
                                            <td>HDD Type</td><td>{asset.hdd_type || ''}</td></tr>
                                        <tr><td>Speaker</td><td>{asset.speaker || ''}</td>
                                            <td>CD Drive</td><td>{asset.cd_drive || ''}</td></tr>
                                    </tbody>
                                </table>
                                <div className="port-info">
                                    <span>Port Information</span>
                                </div>
                                <table className="form-table">
                                    <tbody>
                                        <tr><td>Remarks(if any)</td><td colSpan={3}>{asset.hardware_remarks || ''}</td></tr>
                                        <tr><td>Changes in H/W</td><td>{asset.hardware_changes || ''}</td>
                                            <td>Date</td><td>{formatDate(asset.hardware_change_date) || ''}</td></tr>
                                        <tr><td>Last Updated By</td><td>{asset.last_updated_by || ''}</td>
                                            <td>Last Updated On</td><td>{formatDate(asset.last_updated_on) || ''}</td></tr>
                                    </tbody>
                                </table>
                            </>
                        )}
                    </section>
                </div>
            </div>
        </>
    )
}